import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControleAguaUseCase } from "../../../presentation/useCases/read/get_all_controle_agua_use_case";
import {
  ControleAguaItemModel,
  GetAllControleAguaRequestModel,
  GetAllControleAguaResponseModel,
} from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllControleAguaUseCase
 */
export class GetAllControleAguaUseCase extends BasePaginatedUseCase<ControleAguaItemModel> implements IGetAllControleAguaUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllControleAgua(model: GetAllControleAguaRequestModel): Promise<GetAllControleAguaResponseModel> {
    const response = await this.repository.getAllControleAgua(model);

    // ainda mantém paginação e items pra uso do BasePaginatedUseCase
    this._items = response.itens.items;
    this._totalPages = response.itens.totalPages;
    this._totalItems = response.itens.totalItems;
    this._currentPage = response.itens.currentPage;
    this._pageSize = response.itens.pageSize;

    return response;
  }
}
